import React from 'react';
import { PageHero, SectionTitle, Card } from '../components/PageUI';
import { Headphones, FileText, Video, MessageCircle, PhoneCall, Mail } from 'lucide-react';

const SuportePage = () => {
  const options = [
    { title: 'Base de conhecimento', icon: FileText, desc: 'Guias e artigos com passo a passo.' },
    { title: 'Tutoriais em vídeo', icon: Video, desc: 'Treinamentos rápidos para a equipe.' },
    { title: 'Chat online', icon: MessageCircle, desc: 'Atendimento imediato com especialistas.' },
    { title: 'Telefone/WhatsApp', icon: PhoneCall, desc: 'Suporte humanizado para urgências.' },
    { title: 'E-mail', icon: Mail, desc: 'Solicitações e acompanhamento por ticket.' },
    { title: 'Suporte premium', icon: Headphones, desc: 'SLA dedicado e consultoria contínua.' }
  ];

  return (
    <div>
      <PageHero
        eyebrow="Suporte"
        title="Central de ajuda para sua operação."
        subtitle="Conteúdo, atendimento humano e canais dedicados para acelerar sua rotina."
        primaryCta={{ label: 'Abrir chamado', href: '/contato' }}
      />

      <section className="bg-slate-950">
        <div className="container mx-auto px-8 lg:px-12 py-16">
          <SectionTitle
            eyebrow="Canais"
            title="Escolha o melhor canal de suporte"
            description="Disponível de segunda a sexta, das 8h às 18h."
          />
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {options.map((item) => (
              <Card key={item.title}>
                <item.icon className="w-6 h-6 text-[#FF6B35]" />
                <h3 className="text-xl font-semibold mt-3">{item.title}</h3>
                <p className="text-slate-200/80 mt-2">{item.desc}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default SuportePage;
